/* globals Vue */

import Vue from 'vue/dist/vue.js';


/**
 * This is a custom geo nave input component.
 * This javascript behaves in input_sev_nav.html.twig file with needs to be included
 */
(function () {
    'use strict';

    var MIN_SEARCH_LENGTH = 1,
        parentComponent = document.getElementById("filters-modal"),
        COMPONENT = 'form[data-component="sev_nav_input"]',
        componentList;

    /**
     * Check if components exists in current page before select
     */
    if (COMPONENT != null && parentComponent != null) {
        componentList = parentComponent.querySelectorAll(COMPONENT);
    }
    else {
        componentList = null;
    }

    /**
     * Check if component list exists in current page before initialize
     */
    if (componentList != null) {
        initializeComponent();
    }

    /**
     * Initialize N components
     */
    function initializeComponent() {
        var index, total;

        for (index = 0, total = componentList.length; index < total; index++) {
            setComponentFunctionality(componentList[index]);
        }
    }

    /**
     * Add functionality to a detected component
     * @param {Object|Node} element
     */
    function setComponentFunctionality(element) {
        var selectedId = element.getAttribute('data-selected-id'),
            defaultPho = element.getAttribute('data-default-pho')
        ;

        /* eslint-disable no-new */
        window.inputSevNav = new Vue({
            el: element,
            data: function () {
                return {
                    getPromise: null,
                    placeholder: defaultPho,
                    query: element.getAttribute('data-selected-name'),
                    className: '',
                    spinner: false,
                    results: [],
                    options: window.sevNav || [],
                    clearBtn: false,
                    noResultsLabel: element.getAttribute('data-no-results') || '',
                    isFilled: false,
                    dataId: selectedId
                };
            },
            computed: {
                hasMinimumLength: function () {
                    return this.query.length >= MIN_SEARCH_LENGTH;
                }
            },
            methods: {
                onFocus: function () {
                    this.isFilled = true;

                    // Move cursor to end of query
                    var input = this.$refs['input'];
                    input.value = '';
                    input.value = this.query;

                    setTimeout(() => {
                        input.focus();
                        if (input.scrollWidth) {
                            input.scrollLeft = input.scrollWidth;
                        }
                        this.evaluateQuery();
                    }, 1);
                },
                /**
                 * On click input, check if it has some value and evaluate query
                 */
                checkDefaultQuery: function () {
                    if (this.hasMinimumLength) {
                        this.evaluateQuery();
                    }
                },
                /**
                 * Evaluate input query:
                 * if is grater than minimum required length return only matched results
                 * if is shorter return all the results
                 */
                evaluateQuery: function () {
                    if (this.hasMinimumLength) {
                        this.spinner = true;
                        this.clearBtn = false;

                        setTimeout(() => {
                            this.results = this.getSuggestedResults();
                            if (this.results.length === 0) {
                                this.results = [{
                                    id: '0',
                                    label: this.noResultsLabel
                                }];
                            }
                            this.spinner = false;
                            this.clearBtn = true;
                            this.isFilled = true;
                        }, 400);

                    } else {
                        this.spinner = false;
                        this.results = window.sevNav;
                    }
                },
                /**
                 * Get query matching results
                 * @return {Array}
                 */
                getSuggestedResults: function () {
                    var self = this;

                    return this.options.filter(function (item) {
                        return item.label.toLocaleLowerCase().indexOf(self.query.toLocaleLowerCase()) >= 0;
                    });
                },
                /**
                 * Select option click event callback
                 * @param {String} dirify
                 */
                navigateTo: function (dirify) {
                    window.location.href = dirify;
                },
                /**
                 * Select option click event callback
                 * Transfers its value to the input and clears results
                 * @param {String} value
                 * @param {Number} id
                 */
                printOption: function (value, id) {
                    this.query = value;
                    this.dataId = id;
                    this.className = 'autocomplete-with-result';
                    this.clearResults();
                },
                /**
                 * Clear results
                 */
                clearResults: function () {
                    this.results = [];
                    this.spinner = false;
                    this.clearBtn = false;
                    this.isFilled = false;
                    this.placeholder = defaultPho;
                },
                /**
                 * Clear query
                 */
                clearQuery: function () {
                    this.query = '';
                    this.className = '';
                    this.dataId = 0;
                    this.clearResults();
                },
                /**
                 * Reset auto complete results
                 */
                resetAutoComplete: function () {
                    this.spinner = false;
                    this.clearResults();
                }
            },
            directives: {
                /**
                 * Evaluate document click target in order to detect outside clicks
                 */
                clickOutside: {
                    bind: function (el, binding, vnode) {
                        el.event = function (event) {
                            if (!(el === event.target ||
                                el.contains(event.target) ||
                                event.target.classList.contains('c-auto-complete-item') ||
                                event.target.classList.contains('c-auto-complete-list'))) {
                                vnode.context[binding.expression](event);
                            }
                        };
                        document.body.addEventListener('click', el.event);
                    },
                    unbind: function (el) {
                        document.body.removeEventListener('click', el.event);
                    }
                }
            }
        });
    }

}());
